'use strict';

var AddBusinessDays = function AddBusinessDays(n) {
  var d = new Date();
  var day = d.getDay();
  d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2);
  return d;
};

var FormatDate = function(date) {
  var showYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var year = date.getFullYear().toString().substr(-2);
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (day < 10) {
    day = '0' + day;
  };
  if (month < 10) {
    month = '0' + month;
  };
  return day + '/' + month + (showYear ? '/' + year : '');
};

const FormatDateLong = function(date, showYear = false) {
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const year = date.getFullYear().toString().substr(-2);
  const month = date.getMonth() + 1;
  const day = date.getDate();

  let formattedDate = daysOfWeek[date.getDay()] + ' ' + day + '/' + month;
  if (showYear) {
    formattedDate += '/' + year;
  }

  return formattedDate;
};

const FormatDateWithMonthName = function(date, showYear = false, showDayOfWeek = true) {
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const year = date.getFullYear().toString().substr(-2);
  const month = monthNames[date.getMonth()];
  const day = date.getDate();

  let formattedDate = '';
  if (showDayOfWeek) {
    formattedDate = daysOfWeek[date.getDay()] + ' ';
  }
  formattedDate += day + ' ' + month;
  if (showYear) {
    formattedDate += ' ' + year;
  }

  return formattedDate;
};

function updateSingleEDD(product, showDays = false) {
  let thumbShipFrom = product.querySelector('.thumb-ship-from');
  let from = thumbShipFrom.dataset.shipFrom;
  let ship = window.Countries.shippingWidget.find(function(s) {
    return s.from == from;
  });

  var thumbProductEdd = product.querySelector('.thumb-product-edd');
  if (thumbProductEdd) {
    if (ship) {
      thumbProductEdd.innerHTML = showDays
        ? FormatDateLong(AddBusinessDays(ship.ranges[0].min), false)
        : FormatDateWithMonthName(AddBusinessDays(ship.ranges[0].min), false, false);
    } else {
      thumbProductEdd.innerHTML = 'DD/MM';
    }
  }

  var thumbProductLdd = product.querySelector('.thumb-product-ldd');
  if (thumbProductLdd) {
    if (ship) {
      thumbProductLdd.innerHTML = showDays
        ? FormatDateLong(AddBusinessDays(ship.ranges[0].max), false)
        : FormatDateWithMonthName(AddBusinessDays(ship.ranges[0].max), false, false);
    } else {
      thumbProductLdd.innerHTML = 'DD/MM';
    }
  }
}

document.addEventListener('page:loaded', function() {
  console.log('page:loaded')
  var shipProductsCart = document.querySelectorAll('.cart-item .Ship__product');
  if (shipProductsCart === null || shipProductsCart.length === 0) {
    var shipProducts = document.querySelectorAll('.Ship__product');
    Array.from(shipProducts).forEach(function(product) {
      updateSingleEDD(product);
    });
  } else {
    Array.from(shipProductsCart).forEach(function(product) {
      updateSingleEDD(product, true);
    });
  }
  
});

document.addEventListener('collection:reloaded', function() {
  console.log('collection:reloaded')
  var shipProducts = document.querySelectorAll('.card-information__wrapper .Ship__product');
  Array.from(shipProducts).forEach(function(product) {
    updateSingleEDD(product);
  });
});